import { fetchList } from '@/api/region/region'
import { dataToOpts } from '@/utils/opts'
import _ from 'lodash'

const query = {
  filter: '{status:0}',
  limit: 100,
  sort: 'rank,-id'
}

const region = {
  state: {
    list: [],
    inited: false
  },

  mutations: {
    INIT_REGION: (state, data) => {
      state.inited = true
      state.data = dataToOpts(data)
      state.list = _.cloneDeep(state.data.opts)
    },
    RESET_LANGUAGE: (state) => {
      state.inited = false
    }
  },

  actions: {
    InitRegion ({ commit }) {
      if (this.state.region.inited) {
        return new Promise((resolve) => {
          resolve(this.state.region.data)
        })
      }
      return new Promise((resolve, reject) => {
        fetchList(query).then(res => {
          commit('INIT_REGION', res.data)
          resolve(this.state.region.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    ResetRegion ({ commit }) {
      commit('RESET_LANGUAGE')
    }
  }
}

export default region
